export enum TechStep {
    TECH_DESC = 'TECH_DESC',
    TECH_SUMMARY = 'TECH_SUMMARY',
    TECH_ELEMENTS = 'TECH_ELEMENTS',
    TECH_STRATEGY = 'TECH_STRATEGY',
}

export enum KeywordType {
    TOPIC = 'TOPIC',
    FEATURE = 'FEATURE',
    EFFECT = 'EFFECT',
}
